import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--bg-card)',
      borderTop: '1px solid var(--border-light)',
      padding: '80px 0 40px'
    }}>
      <div className="container" style={{
        maxWidth: '87.5rem',
        margin: '0 auto',
        padding: '0 40px'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '60px',
          marginBottom: '60px'
        }}>
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_corporate-concierge/artifacts/42z9uo0n_Agence%20PNG.png"
              alt="L'Agence"
              style={{
                height: '55px',
                width: 'auto',
                marginBottom: '20px'
              }}
            />
            <p className="body-small" style={{
              marginBottom: '20px',
              maxWidth: '300px'
            }}>
              Billeterie corporate, voyages d'affaires clés-en-main et événements internationaux.
            </p>
            <div className="caption" style={{
              color: 'var(--text-secondary)'
            }}>
              Service exclusif 24/7
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="heading-4" style={{
              color: 'var(--brand-primary)',
              marginBottom: '20px',
              textTransform: 'uppercase',
              fontSize: '1rem'
            }}>
              Services
            </h3>
            <ul style={{
              listStyle: 'none',
              padding: 0
            }}>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/billeterie" className="body-small" style={{
                  textDecoration: 'none',
                  color: 'var(--text-secondary)',
                  transition: 'color 0.3s ease'
                }}>
                  Billeterie Corporate
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/affretement" className="body-small" style={{
                  textDecoration: 'none',
                  color: 'var(--text-secondary)',
                  transition: 'color 0.3s ease'
                }}>
                  Affrètement d'Avions
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/voyages" className="body-small" style={{
                  textDecoration: 'none',
                  color: 'var(--text-secondary)',
                  transition: 'color 0.3s ease'
                }}>
                  Voyages d'Affaires
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/evenements" className="body-small" style={{
                  textDecoration: 'none',
                  color: 'var(--text-secondary)',
                  transition: 'color 0.3s ease'
                }}>
                  Événements Corporate
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="heading-4" style={{
              color: 'var(--brand-primary)',
              marginBottom: '20px',
              textTransform: 'uppercase',
              fontSize: '1rem'
            }}>
              Contact
            </h3>
            <ul style={{
              listStyle: 'none',
              padding: 0
            }}>
              <li style={{
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <Mail size={16} color="var(--brand-primary)" />
                <a href="mailto:info@agence-cd.com" className="body-small" style={{
                  textDecoration: 'none',
                  color: 'var(--text-secondary)'
                }}>
                  info@agence-cd.com
                </a>
              </li>
              <li style={{
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <Phone size={16} color="var(--brand-primary)" />
                <a href="tel:+243841223949" className="body-small" style={{
                  textDecoration: 'none',
                  color: 'var(--text-secondary)'
                }}>
                  +243 841 223 949
                </a>
              </li>
              <li style={{
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px'
              }}>
                <MapPin size={16} color="var(--brand-primary)" style={{ marginTop: '4px' }} />
                <span className="body-small" style={{
                  color: 'var(--text-secondary)'
                }}>
                  Kinshasa, RDC
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          paddingTop: '40px',
          borderTop: '1px solid var(--border-light)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <div className="caption" style={{
            color: 'var(--text-muted)'
          }}>
            © 2025 L'Agence. Tous droits réservés.
          </div>
          <div style={{
            display: 'flex',
            gap: '30px'
          }}>
            <Link to="/" className="caption" style={{
              textDecoration: 'none',
              color: 'var(--text-muted)',
              transition: 'color 0.3s ease'
            }}>
              Mentions Légales
            </Link>
            <Link to="/" className="caption" style={{
              textDecoration: 'none',
              color: 'var(--text-muted)',
              transition: 'color 0.3s ease'
            }}>
              Confidentialité
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        footer a:hover {
          color: var(--brand-primary) !important;
        }
      `}</style>
    </footer>
  );
};

export default Footer;